import { render, staticRenderFns } from "./InfoAlert.vue?vue&type=template&id=7b3d27dc"
import script from "./InfoAlert.vue?vue&type=script&lang=ts"
export * from "./InfoAlert.vue?vue&type=script&lang=ts"
import style0 from "./info-alert.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports